import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getFirestore, Timestamp, serverTimestamp, collection, doc, setDoc, getDoc, addDoc, query, where, getDocs, getCountFromServer, updateDoc, deleteDoc, onSnapshot, writeBatch, FieldValue, orderBy, limit } from 'firebase/firestore';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

const firebaseConfig = {
  apiKey: 'AIzaSyCocDTtuzbHF906UAjkH0AoKYiGsklxqo4',
  authDomain: 'homeme-aa708.firebaseapp.com',
  projectId: 'homeme-aa708',
  storageBucket: 'homeme-aa708.appspot.com',
  messagingSenderId: '189587773597',
  appId: '1:189587773597:web:7e3fff77dd0b992dc99c74'
};

// Validate that environment variables are set
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error(
    "Firebase configuration is missing. " +
    "Ensure you have a .env file in the project root with all VITE_FIREBASE_ variables set. " +
    "Refer to firebase.ts for the required variables."
  );
  // Potentially throw an error or display a more user-friendly message in the UI
}


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1');

export { 
  auth, 
  db, 
  storage, 
  functions,
  httpsCallable,
  Timestamp, 
  serverTimestamp, 
  collection, 
  doc, 
  setDoc, 
  getDoc, 
  addDoc, 
  query, 
  where, 
  getDocs, 
  getCountFromServer,
  updateDoc, 
  deleteDoc, 
  onSnapshot,
  writeBatch,
  storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  orderBy, // Export orderBy
  limit
};
export type { FieldValue }; // Export FieldValue type for serverTimestamp etc.
